import * as NativeAxios from 'axios';
import * as ReactRedux from 'react-redux';
import {axios, resetAllCookieClicks, venditshop} from '../../index';
import {displayToastUpdate, receiveLoadingUpdate} from '../../redux/actions';

const KameraModal = React.lazy(() => import('./KameraModal'));

class Schnellerfassung extends React.PureComponent {
    constructor(props) {
        super(props);
        this.blurTimeout = 0;
        this.changeTimeout = 0;
        this.cancelToken = null;
        this.state = {
            searchTerm: '',
            searchResult: [],
            focusedResult: null,
            searchInputFocus: false,
            selectedResult: null,
            showSearchResult: false,
            cameraModal: false,
            cameraModalProduct: null,
            cameraModelError: null
        };
        this.searchRef = React.createRef();
        this.mengeRef = React.createRef();
        this.resultRefs = [];

        this.search = () => {
            window.location.href = (props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname : '') + '/search/all/?search=' + encodeURIComponent(this.state.searchTerm);
        };
        this.handleKeySearch = (e) => {
            if (e.keyCode === 13) {
                this.search();
            }
        };

        this.querySearchResult = async (val) => {
            const altpreisig = true;
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }
            if (
                typeof val !== 'undefined' && val !== null && val !== '' && (val && val.trim() ? val.trim() !== '' : true)) {
                const CancelToken = NativeAxios.CancelToken;
                const source = CancelToken.source();
                this.cancelToken = source;
                let result = null;
                try {

                    this.setState({searchResult: [{loading: 'true'}]});
                    const isAktion = this.props?.meta?.conf?.schnellerfassungAngebot || false;

                    result = await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '') + '/search/', {
                        searchTerm: val,
                        nurBuchbar: this.props.nurBuchbar,
                        ohneKategorien: this.props.ohneKategorien,
                        altpreisig: altpreisig,
                        isaktion: isAktion
                    }, {cancelToken: source.token});

                    this.setState({
                        searchResult: result.data,
                        focusedResult: null
                    }, this.handleEanInput);
                } catch (e) {
                    if (NativeAxios.isCancel(e)) {
                        // nichts tun
                    } else {
                        this.setState({
                            searchResult: [],
                            focusedResult: null,
                            selectedResult: null
                        });
                    }
                }
            } else {
                this.setState({
                    searchResult: [],
                    focusedResult: null,
                    selectedResult: null
                });
            }
        };

        this.querySearchResultNumeric = async (val) => {
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }
            if (
                typeof val !== 'undefined' && val !== null && val !== '' && (val && val.trim() ? val.trim() !== '' : true)) {
                const CancelToken = NativeAxios.CancelToken;
                const source = CancelToken.source();
                this.cancelToken = source;
                try {
                    let result = null;
                    const isAktion = this.props?.meta?.conf?.schnellerfassungAngebot || false;
                    result = await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : '') + '/search/numeric/', {
                        searchTerm: val,
                        nurBuchbar: this.props.nurBuchbar,
                        isaktion: isAktion
                    }, {cancelToken: source.token});

                    this.setState({
                        searchResult: result.data,
                        focusedResult: null
                    }, this.handleEanInput);
                } catch (e) {
                    if (NativeAxios.isCancel(e)) {
                        // nichts tun
                    } else {
                        this.setState({
                            searchResult: [],
                            focusedResult: null,
                            selectedResult: null
                        });
                    }
                }
            } else {
                this.setState({
                    searchResult: [],
                    focusedResult: null,
                    selectedResult: null
                });
            }
        };

        this.handleEanInput = () => {
            if (!this.state.searchResult || !this.state.searchResult.length) {
                this.setState({
                    cameraModelError: this.state.searchTerm,
                    cameraModalProduct: null
                });
            }
            if (!this.props.suche && this.state.searchResult && this.state.searchResult.length === 1 &&
                venditshop.helper.checkEan(this.state.searchTerm)) {

                // Ein Ergebnis + EAN-Input, hinzufügen
                if (this.props?.meta?.licenseCache?.barcodeScannenGroesserVerkaufseinheit && this.state.searchResult[0]?.menge > 1) {
                    this.mengeRef.current.value = this.state.searchResult[0].menge;
                }
                this.setState({selectedResult: this.state.searchResult[0]}, this.add);
            }

            //hier
            this.props?.changeLoading(false);
        };

        this.handleNumericInput = () => {
            if (!this.props.suche && this.state.searchResult && this.state.searchResult.length === 1 &&
                this.state.searchTerm && !isNaN(this.state.searchTerm)) {
                // Ein Ergebnis + Numeric-Input, hinzufügen
                this.setState({selectedResult: this.state.searchResult[0]}, this.add);
            }
        };

        this.handleChange = (e, value = '', forcesearch = false) => {
            const val = e?.target?.value || value;

            window.clearTimeout(this.changeTimeout);
            let callback = null;
            if (forcesearch) {
                callback = () => this.search();
            }
            if (venditshop.helper.checkEan(val)) {
                if (!callback) {
                    callback = () => this.querySearchResult(val);
                }
                this.setState({
                    searchTerm: val,
                    selectedResult: null
                }, callback);
            } else if (!isNaN(val) && val.substring(0, 1) != '0') {
                if (!callback) {
                    callback = () => this.querySearchResultNumeric(val);
                }
                this.setState({
                    searchTerm: val,
                    selectedResult: null
                });
                //Hier der Timeout
                this.changeTimeout = window.setTimeout(callback, 384);
            } else {
                if (!callback) {
                    callback = () => this.querySearchResult(val);
                }
                this.setState({
                    searchTerm: val,
                    selectedResult: null
                });
                this.changeTimeout = window.setTimeout(callback, 384);
            }
        };

        this.handleFocus = () => {
            this.setState({focusedResult: null}, () => {
                if (!this.state.searchResult.length) {
                    this.querySearchResult(this.state.searchTerm);
                }
            });
        };

        this.handleBlurWrap = () => {
            this.blurTimeout = window.setTimeout(() => {
                this.setState({showSearchResult: false});
            }, 128);
        };

        this.handleFocusWrap = () => {
            // if (!props.mobile) {
            window.clearTimeout(this.blurTimeout);
            this.setState({showSearchResult: true});
            // }
        };

        this.handleKeyDownMenge = (e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
                this.add();
            }
        };

        this.handleKeyDown = (e) => {
            if (this.state.searchResult && this.state.searchResult.length &&
                ([38, 40, 9, 13].includes(e.keyCode))) {
                if (this.state.searchResult.filter((r) => r?.loading).length) {
                    return;
                }
                if (!this.props.suche && (e.keyCode === 13 || e.keyCode === 9) && this.state.searchResult.length === 1) {
                    this.setState({focusedResult: 0}, this.select);
                } else if (this.props.meta.conf.schnellerfassungShowMore && (e.keyCode === 13 || e.keyCode === 9) && this.state.focusedResult == null) {
                    this.search();
                } else if (!this.props.suche && e.keyCode === 13) {
                    this.select();
                } else if (e.keyCode !== 13) {
                    const elements = this.resultRefs.filter((r) => r?.current != null).map((r) => r.current);
                    e.preventDefault();
                    let nextFocus;
                    let inputFocus = false;
                    // up
                    if (e.keyCode === 38 || (e.keyCode === 9 && e.shiftKey === true)) {
                        if (this.state.focusedResult !== null) {
                            nextFocus = this.state.focusedResult - 1;
                            if (nextFocus < 0) {
                                if (this.state.searchInputFocus === false) {
                                    inputFocus = true;
                                } else {
                                    if (this.state.searchResult.length >= 11) {
                                        nextFocus = this.state.searchResult.length - 2;
                                    } else {
                                        nextFocus = this.state.searchResult.length - 1;
                                    }
                                    if (nextFocus < 0) {
                                        nextFocus = 0;
                                    }
                                }
                            }
                        } else {
                            if (this.state.searchResult.length >= 11) {
                                nextFocus = this.state.searchResult.length - 2;
                            } else {
                                nextFocus = this.state.searchResult.length - 1;
                            }
                            if (nextFocus < 0) {
                                nextFocus = 0;
                            }
                        }
                    }
                    // down
                    if (e.keyCode === 40 || (e.keyCode === 9 && e.shiftKey === false)) {
                        if (this.state.focusedResult !== null) {
                            nextFocus = this.state.focusedResult + 1;
                            if (this.state.searchResult.length >= 11) {
                                if (nextFocus > this.state.searchResult.length - 2) {
                                    if (this.state.searchInputFocus === false) {
                                        inputFocus = true;
                                    } else {
                                        nextFocus = 0;
                                    }
                                }
                            } else {
                                if (nextFocus > this.state.searchResult.length - 1) {
                                    if (this.state.searchInputFocus === false) {
                                        inputFocus = true;
                                    } else {
                                        nextFocus = 0;
                                    }
                                }
                            }
                        } else {
                            nextFocus = 0;
                        }
                    }
                    this.setState({
                        focusedResult: nextFocus,
                        searchInputFocus: inputFocus,
                        selectedResult: null
                    }, () => {
                        if (this.state.searchInputFocus === true) {
                            this.searchRef.current.focus();
                        } else {
                            elements[nextFocus].focus();
                        }
                    });
                }
            }
        };

        this.select = () => {
            console.log('select');
            if (this.state.searchResult && this.state.searchResult.length && this.state.focusedResult !== null) {
                const result = this.state.searchResult[this.state.focusedResult];

                this.setState({
                    selectedResult: result,
                    searchTerm: venditshop.helper.fix_euro_sign(result.bezeichnung),
                    focusedResult: null,
                    searchInputFocus: null
                }, () => {
                    this?.mengeRef?.current?.value
                    window.setTimeout(() => {
                        //Der Wert in der Menge darf nicht gesetzt werden, wenn kein searchResult vorhanden ist.
                        if (!this?.state?.selectedResult) {
                            return;
                        }
                        if (!this.mengeRef.current.value) {
                            this.mengeRef.current.value = 1;
                        }
                        if (this.props?.retoure) {
                            this.add();
                        } else {
                            this.mengeRef.current.select();
                        }
                    }, 0);

                });
            }
        };

        this.highlight = (id, text, verpackung, isCategory, fakturiertext, fakturierstop, produktart, kvp, isaktion) => {
            verpackung =
                typeof verpackung === 'undefined' || !verpackung ? '' : '<span class="verpackung">(' + verpackung + ')</span>';
            isCategory = isCategory || false;
            fakturierstop = fakturierstop || false;
            fakturiertext =
                typeof fakturiertext === 'undefined' || !fakturiertext ? '' : '<span class="fakturiertext' + (fakturierstop
                    ? ' error'
                    : '') + '">(' + fakturiertext + ')</span>';
            const reg = '(' + venditshop.helper.escape_regex(this.state.searchTerm).split(' ').join('|') + ')';
            return {
                __html: (isCategory
                        ? 'Kategorie: '
                        : (produktart === 'b'
                            ? 'Börse: '
                            : '') + ((id + '').replace(new RegExp('^' + reg, 'gi'), (str) => '<strong>' + str + '</strong>')) +
                        ' - ')
                    + (isaktion ? '<b>Achtung Aktion!&nbsp;</b>' : '')
                    + (text.replace(new RegExp(reg, 'gi'), (str) => '<strong>' + str + '</strong>')) +
                    verpackung + fakturiertext + (this?.props?.retoure && kvp
                        ? ' <strong>KVP ' + venditshop.helper.formatCurrency(kvp) + '</strong>'
                        : '')
            };
        };

        this.add = () => {
            if (this.state.selectedResult) {

                let fakturierhinweis = {
                    text: this.state.selectedResult.fakturiertext,
                    fakturierstop: this.state.selectedResult.fakturierstop,
                    id: this.state.selectedResult.id,
                    bezeichnung: venditshop.helper.fix_euro_sign(this.state.selectedResult.bezeichnung)
                };

                if (!this.state.selectedResult.fakturierstop || this.props.meta?.customer?.gvl) {
                    if (this.state.cameraModal) {
                        this.setState({
                            cameraModalProduct: this.state.selectedResult,
                            cameraModelError: null
                        });
                    }
                    // console.log('Bin ich hier richtig? ');
                    // console.log(this.state.selectedResult, (this.mengeRef.current.value || 1), false,
                    //     (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''));

                    this.props.addCallback(this.state.selectedResult, (this.mengeRef.current.value || 1), false,
                        (this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname : ''));
                }

                if (this.props.meta?.customer?.gvl) {
                    fakturierhinweis = null;
                }

                this.setState({
                    searchTerm: '',
                    searchResult: [],
                    focusedResult: null,
                    selectedResult: null,
                    fakturierhinweis: fakturierhinweis
                }, () => {
                    this.mengeRef.current.value = '';
                    if (!this.state.cameraModal) {
                        this.searchRef.current.focus();
                    }
                });
            }
        };

    }

    static defaultProps = {
        suche: false,
        maintenance: false,
        nurBuchbar: false,
        ohneKategorien: false,
        addCallback: () => {
        }
    };

    render() {
        const props = this.props;
        const mobile = props.mobile || false;
        const medium = props.medium || false;
        const retoure = props.retoure || false;
        const meta = this.props.meta || {};
        const conf = meta.conf || {};
        let searchResult = null;
        if (this.props.suche) {
            let kamera_button = null;
            if (this.props.maintenance) {
                if (mobile) {
                    kamera_button =
                        <button className="camera" type="button"><i className="icon fas fa-camera"/></button>;
                }
                return <form className="_Suche" onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                }}>
                    <div className="input-wrap">
                        <div>
                            <input placeholder="Suche..." name="searchTerm" value={this.state.searchTerm}
                                   onChange={this.handleChange} onFocus={this.handleFocus} autoComplete="off"
                                   onKeyDown={this.handleKeySearch}/>
                            {kamera_button}
                            <button tabIndex="-1" className="search" aria-label={'suche'}
                                    onClick={() => resetAllCookieClicks()}>
                                <i className="icon fas fa-search"/>
                            </button>
                        </div>
                    </div>
                </form>;
            } else {
                if (mobile) {
                    kamera_button = <button type="button" className="camera" onClick={() => {
                        navigator.mediaDevices.getUserMedia({video: true}).then((stream) => {
                            this.setState({cameraModal: true});
                        });
                    }}><i
                        className="icon fas fa-camera"/></button>;
                }
                let kamera_modal = null;
                if (this.state.cameraModal) {
                    kamera_modal = <KameraModal scanAction={(val) => {
                        this.setState({
                            cameraModal: false
                        }, () => {
                            this.handleChange(null, val, true);
                        });
                    }}
                                                closeAction={() => this.setState({cameraModal: false})}/>;
                }

                let slice = 10;
                if (mobile && !medium) {
                    slice = 5;
                }


                if (this.state.searchTerm && this.state.searchResult && this.state.searchResult.length &&
                    this.state.showSearchResult
                ) {
                    const tmp = this.state.searchResult || [];
                    searchResult = <div className="search_result">
                        {
                            tmp.slice(0, slice).map((r, k) => {
                                if (r?.loading) {
                                    return <a>lädt...</a>;
                                }
                                this.resultRefs[k] = this.resultRefs[k] || React.createRef();
                                const produktart = r?.produkttyp || (r?.boerse ? 'b' : null) || (r?.artikel ? 'a' : null);
                                const id = r.id || r.boerse || r.artikel;
                                //hier
                                if (produktart === 'k') {
                                    return <a key={`category_${id}`} ref={this.resultRefs[k]}
                                              href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname : '') + '/category/' + r.id + '/' +
                                                  venditshop.helper.stripStringForUrl(venditshop.helper.fix_euro_sign(r.bezeichnung)) + '/'}
                                              dangerouslySetInnerHTML={this.highlight(id, venditshop.helper.fix_euro_sign(r.bezeichnung), r.verpackung, true, r.isaktion)}/>;
                                } else {

                                    return <a key={`${produktart}_${id}`} ref={this.resultRefs[k]}
                                              onClick={() => mobile ? this.props?.changeLoading(true) : null}
                                              href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname : '') + `/product/${produktart}/${id}/${venditshop.helper.stripStringForUrl(venditshop.helper.fix_euro_sign(r.bezeichnung))}/`}
                                              dangerouslySetInnerHTML={this.highlight(id, venditshop.helper.fix_euro_sign(r.bezeichnung), r.verpackung, false, null,
                                                  null,
                                                  produktart, r?.kvp, r.isaktion
                                              )}/>;
                                }
                            })
                        }
                        {tmp.length > slice ? <div>{conf.searchTextSuggestion.replace('10', slice)}</div> : null}
                    </div>;
                }

                return <form className="_Suche" onKeyDown={this.handleKeyDown} onFocus={this.handleFocusWrap}
                             onBlur={this.handleBlurWrap} onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                }}>
                    <div className="input-wrap">
                        <div>
                            <input ref={this.searchRef} placeholder="Suche..." name="searchTerm"
                                   value={this.state.searchTerm}
                                   onChange={this.handleChange} onFocus={this.handleFocus} autoComplete="off"
                                   onKeyDown={this.handleKeySearch}/>
                            {kamera_button}
                            <button tabIndex="-1" className="search" onClick={this.search} aria-label={'suche'}>
                                <i className="icon fas fa-search"/>
                            </button>
                        </div>
                        {searchResult}
                    </div>
                    {kamera_modal}
                </form>;
            }
        } else {
            if (this.state.searchTerm && this.state.searchResult && this.state.searchResult.length &&
                !this.state.selectedResult && this.state.showSearchResult) {
                const tmp = this.state.searchResult || [];
                searchResult = <div className="search_result">
                    {
                        tmp.slice(0, 10).map((r, k) => {
                            let classname = null;
                            if (k === this.state.focusedResult) {
                                classname = 'focus';
                            }
                            if (r?.loading) {
                                return <a>lädt...</a>;
                            }
                            this.resultRefs[k] = this.resultRefs[k] || React.createRef();
                            return <span className={classname} key={`${r.produkttyp}_${r.id}`} ref={this.resultRefs[k]}
                                         data-produkttyp={r.produkttyp}
                                         data-produkt={r.id}

                                         onMouseOver={() => {
                                             this.setState({focusedResult: k});
                                         }
                                         }
                                         onMouseEnter={() => {
                                             this.setState({focusedResult: k});
                                         }
                                         }
                                         onMouseDown={() => {
                                             this.setState({focusedResult: k});
                                             this.select();
                                         }}
                                         onTouchEnd={() => {
                                             this.setState({focusedResult: k});
                                             this.select();
                                         }
                                         } dangerouslySetInnerHTML={
                                this.highlight(r.id, venditshop.helper.fix_euro_sign(r.bezeichnung), r.verpackung,
                                    false, r.fakturiertext, r.fakturierstop, null, r.kvp, r.isaktion)
                            }/>;
                        })
                    }
                    {tmp.length > 10 ? <div>{conf.searchTextSuggestion}</div> : null}
                </div>;
            }
            let fakturierhinweis = null;
            const fakturierhinweisClasses = ['fakturierhinweis'];
            if (this.state.fakturierhinweis && this.state.fakturierhinweis.text) {
                let fakturierhinweisIcon;
                if (this.state.fakturierhinweis.fakturierstop) {
                    fakturierhinweisClasses.push('error');
                    fakturierhinweisIcon = <i className="icon fas fa-exclamation-circle"/>;
                } else {
                    fakturierhinweisIcon = <i className="icon fas fa-info-circle"/>;
                }
                const tmp = this.state.fakturierhinweis;
                fakturierhinweis = <div className={fakturierhinweisClasses.join(' ')}>
                    {fakturierhinweisIcon}{tmp.id + ' - ' + venditshop.helper.fix_euro_sign(tmp.bezeichnung) + ': ' + tmp.text}
                </div>;
            }
            let kamera_button = null;
            if (mobile) {
                kamera_button = <button className="camera" type="button" onClick={() => {

                    navigator.mediaDevices.getUserMedia({video: true}).then((stream) => {
                        this.setState({cameraModal: true});
                    });
                }}><i
                    className="icon fas fa-camera"/></button>;
            }
            let kamera_modal = null;
            if (this.state.cameraModal) {
                kamera_modal = <KameraModal product={this.state.cameraModalProduct}
                                            error={this.state.cameraModelError}
                                            fakturierhinweis={this.state.fakturierhinweis}
                                            schnellerfassung={!(this.props?.ordersatz)} scanAction={async (val) => {
                    // handle change
                    if (this.props?.ordersatz) {
                        this.setState({
                            cameraModal: false
                        }, () => {
                            this.handleChange(null, val);
                        });
                    } else {
                        this.setState({searchTerm: val});
                        this.props?.changeLoading(true);
                        await this.querySearchResultNumeric(val);
                        // this.props?.changeLoading(false);
                    }
                }
                }
                                            closeAction={() => {
                                                this.setState({
                                                    cameraModal: false,
                                                    cameraModalProduct: null,
                                                    fakturierhinweis: null,
                                                    error: null
                                                });
                                            }}/>;
            }
            const onchange = retoure ? this.handleChangeRetoure : this.handleChange;
            return <form className="_Schnellerfassung" action="" onSubmit={(e) => {
                e.preventDefault();
                //am 27.5 wurde nur mobile hinzugefügt
                //95332
                //dort gab es Probleme das direkt die Artikle hinzugefügt worden sind
                // if (this?.mengeRef?.current?.value !== ''
                //     // && mobile Ich habe es wieder entfernt, da sosnt der hinzufügen buto nicht mehr geht
                // ) {
                //   this.add();
                // }

                return false;
            }}>
                <h4 className={'header'}>Schnellerfassung</h4>
                <label className="label-suche"
                       onKeyDown={this.handleKeyDown}
                       onFocus={this.handleFocusWrap}
                       onBlur={this.handleBlurWrap}
                >
                    <span>{retoure ? 'EAN' : 'Nummer/Bezeichnung/EAN'}</span>
                    <input type="text" ref={this.searchRef} value={this.state.searchTerm}
                           onChange={onchange}
                           onFocus={this.handleFocus}
                           autoComplete="off"/>{searchResult}
                </label>
                {kamera_button}
                <label className="label-menge" onKeyDown={this.handleKeyDownMenge}>
                    <span>Menge</span>
                    <input type="number" ref={this.mengeRef} min="1" max="999" step="1"/>
                </label>
                <button onClick={() => {
                    if (this?.mengeRef?.current?.value !== '') {
                        this.add();
                    }
                }}
                >{mobile ? <i className="icon fa fa-plus"/> : 'hinzufügen'}</button>
                {fakturierhinweis}

                {kamera_modal}

            </form>;
        }
    }
}

export default ReactRedux.connect((state) => ({
    meta: state.meta,
    mobile: state.mobile.isMobile,
    medium: state.mobileMedium.isMedium
}), (dispatch) => ({
    changeLoading: (loading) => {
        dispatch(receiveLoadingUpdate(loading));
    },
    displayToast: (bool) => {
        dispatch(displayToastUpdate(bool));
    }
}))(Schnellerfassung);
